export enum QAPriority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}

export const QA_PRIORITIES: QAPriority[] = [
  QAPriority.LOW,
  QAPriority.MEDIUM,
  QAPriority.HIGH,
]

export const getQAPriorityMeta = (priority: QAPriority, t: (k: string) => string) => {
  switch (priority) {
    case QAPriority.LOW:
      return {
        label: t('project.views.QuestionAnswerAdd.priority.low'),
        fullLabel: t('project.views.QuestionAnswerAdd.priority.lowFull'),
        icon: 'angles-down',
        iconColor: 'info-darken-1',
        locatorValue: 'qa-priority-low',
      }

    case QAPriority.HIGH:
      return {
        label: t('project.views.QuestionAnswerAdd.priority.high'),
        fullLabel: t('project.views.QuestionAnswerAdd.priority.highFull'),
        icon: 'angles-up',
        iconColor: 'red-500',
        locatorValue: 'qa-priority-high',
      }

    case QAPriority.MEDIUM:
    default:
      return {
        label: t('project.views.QuestionAnswerAdd.priority.medium'),
        fullLabel: t('project.views.QuestionAnswerAdd.priority.mediumFull'),
        icon: 'equals',
        iconColor: 'yellow-500',
        locatorValue: 'qa-priority-medium',
      }
  }
}
